import React from "react";
import TaskItem from "./taskItem";
import ITask from "../interfaces/ITask";

export interface ITaskListProps {
    items: ITask[];
    showOwner: boolean;
    completeTask: (id: string, projectId?: string) => void;
}

const TaskList: React.FunctionComponent<ITaskListProps> = ({ items, showOwner, completeTask }) => {
    return (
        <>
            {items.map((item: ITask) =>
                <TaskItem key={item.id} completeTask={completeTask} showOwner={showOwner} {...item} />)
            }
        </>
    );
};

export default TaskList;
